<template>
    <ul class="filters__facet">
        <li class="filters__item">
            <h3 class="filters__title">{{ name | titleCase }}</h3>

            <ul class="filters__options">
                <li
                    v-for="option in options"
                    :key="`f-g-${name}-${option.value}`"
                >
                    <FormulateInput
                        v-model="value"
                        :options="[option]"
                        type="customCheckbox"
                    />
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { kebabToTitle } from '@/helpers'

export default {
    props: {
        name: { type: String, required: true },
        options: { type: Array, required: true }
    },

    computed: {
        ...mapState('Resources', ['searchFilters']),

        value: {
            get () { return this.searchFilters[this.name] },
            set (newVal) { this.setSearchFilters({name: this.name, newVal}) }
        }
    },

    filters: {
        titleCase (val) {
            return kebabToTitle(val)
        }
    },

    methods: {
        ...mapActions('Resources', ['setSearchFilters'])
    }
}
</script>

